'use client'

import cx from 'classnames'
import React from 'react'

import Animation from '@/components/LandingPage/ContentModel/Animation'

export default function GradientTextAnimation({
  text,
  random = true,
  // NOTE: 画面の下から20%の位置に来たら表示する
  rootMargin = '0px 0px -20% 0px',
  delay = 0,
}: {
  text: string
  random?: boolean
  rootMargin?: string
  delay?: number
}) {
  const textArray = text.split('').slice(0, 200)
  const animationIndex = Array.from({ length: textArray.length }, (_, i) => i + 1 + delay)
  if (random) {
    animationIndex.sort(() => Math.random() - 0.5)
  }

  return (
    <>
      {/*NOTE: Taiwindでsafelistに入れているので最長100文字までしか利用できない */}
      {textArray.map((char, index) => {
        if (char === '\n') {
          return <br key={index} />
        }
        return (
          <Animation
            key={index}
            animationClassName={cx(`animate-gradient-text-${animationIndex[index]}`)}
            rootMargin={rootMargin}
            isTransparent={true}
            targetComponent={({ animationRef, className, style }) => (
              <span ref={animationRef} className={className} style={style}>
                {char === ' ' ? <>&nbsp;</> : char}
              </span>
            )}
          />
        )
      })}
    </>
  )
}
